import { PageName, getRouteFromPath } from '@amzn/atoz-shiftapp-initializer';
import { DashboardPageDocument, FindShiftsPageCountsDocument, FindShiftsPageDocument, FindShiftsPageMoreDocument, SchedulePageDocument } from '@amzn/atoz-shiftapp-types';
import { logger } from '@amzn/atoz-shiftapp-metrics';
export var getOpportunitiesRefetchQuery = function (path, isFindShiftsRedesign) {
    var pageName = getRouteFromPath(path);
    if (pageName === PageName.Dashboard) {
        return [DashboardPageDocument];
    }
    if (pageName === PageName.FindShifts && isFindShiftsRedesign) {
        return [
            FindShiftsPageDocument,
            FindShiftsPageMoreDocument,
            FindShiftsPageCountsDocument
        ];
    }
    if (pageName === PageName.FindShifts) {
        return [FindShiftsPageDocument];
    }
    if (pageName === PageName.MySchedule) {
        return [SchedulePageDocument];
    }
    logger.emitError('Opportunities refetch after mutation called in an unspecified route. Unable to refetch queries after mutation.', {
        context: { path: path }
    });
    return [];
};
